import { Asn } from 'core/api'
import { ShippingOperationConfig, SimpleParcelListOperationConfig } from 'core/shared'
import { CustomFieldKeyTitle } from 'core/shared/utils'

export * from 'core/shared/utils'

export const getLanguages = () => {
  return [
    { label: 'English', value: 'en' },
    { label: 'Italiano', value: 'it' },
    { label: 'Japanese', value: 'ja' },
    { label: 'Chinese (Traditional)', value: 'zh' },
    { label: 'Français', value: 'fr' }
  ]
}

export function showSpecificAsnFields(
  asn: Asn,
  operationConfig?: ShippingOperationConfig | SimpleParcelListOperationConfig
): CustomFieldKeyTitle[] | undefined {
  
  
  if (operationConfig && operationConfig.type === 'INBOUND' && operationConfig.code.includes('sap')) {
    let result: CustomFieldKeyTitle[] = []
    result = [{key:'ddtNumber', title: 'DDT'},{key:'attributes.ExtDelivID', title:'ExtDelivID'}]
    return result;
  }
  
  
  return undefined
}

export function getAsnShippingDate(
  asn: Asn,
  operationConfig?: ShippingOperationConfig | SimpleParcelListOperationConfig
): string | undefined {
  if (operationConfig?.type === 'INBOUND') {
    return asn.ddtDate || asn.shippingDate
  }
  return asn.shippingDate
}
